import { categories } from "@/mocks/categories";

interface FilterPanelProps {
  category: string;
  status: string;
  sort: string;
  onCategoryChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onSortChange: (value: string) => void;
  onReset: () => void;
}

const statusOptions = [
  { id: "all", label: "全部状态" },
  { id: "连载", label: "连载中" },
  { id: "完结", label: "已完结" },
];

const sortOptions = [
  { id: "hot", label: "人气最高" },
  { id: "update", label: "最近更新" },
  { id: "rating", label: "评分最高" },
];

function GroupTitle({ icon, text }: { icon: string; text: string }) {
  return (
    <h3 className="flex items-center gap-2 font-heading font-semibold text-sm text-foreground-950 mb-3">
      <i className={`${icon} text-accent-600 text-base`}></i>
      {text}
    </h3>
  );
}

export default function FilterPanel({
  category,
  status,
  sort,
  onCategoryChange,
  onStatusChange,
  onSortChange,
  onReset,
}: FilterPanelProps) {
  return (
    <div className="flex flex-col gap-6">
      <div>
        <GroupTitle icon="ri-price-tag-3-line" text="漫画题材" />
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => onCategoryChange("all")}
            className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors cursor-pointer ${
              category === "all"
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-600 hover:bg-background-200"
            }`}
          >
            全部
          </button>
          {categories.map((cat) => (
            <button
              key={cat.id}
              type="button"
              onClick={() => onCategoryChange(cat.id)}
              className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors cursor-pointer ${
                category === cat.id
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>
      </div>

      <div>
        <GroupTitle icon="ri-loader-4-line" text="连载状态" />
        <div className="flex flex-wrap gap-2">
          {statusOptions.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => onStatusChange(item.id)}
              className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors cursor-pointer ${
                status === item.id
                  ? "bg-secondary-500 text-white"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>

      <div>
        <GroupTitle icon="ri-sort-desc" text="排序方式" />
        <div className="flex flex-col gap-2">
          {sortOptions.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => onSortChange(item.id)}
              className={`flex items-center justify-between px-3 py-2 rounded-md text-xs font-medium transition-colors cursor-pointer ${
                sort === item.id
                  ? "bg-accent-100 text-accent-800"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {item.label}
              {sort === item.id && <i className="ri-check-line text-base"></i>}
            </button>
          ))}
        </div>
      </div>

      <button
        type="button"
        onClick={onReset}
        className="flex items-center justify-center gap-2 h-10 rounded-md border border-background-300 text-sm text-foreground-600 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
      >
        <i className="ri-refresh-line"></i>
        重置筛选条件
      </button>
    </div>
  );
}